import './sass/main.scss'
import AppRoutes from './AppRoutes';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScannerHandler from './components/ScannerComponent';
import ScannerComponent from './components/ScannerComponent';
import { API } from './utils/Api';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

function App() {
  const token = localStorage.getItem("token");
  const [scannedData, setScannedData] = useState("");

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const handleScan = async (e) => {
  //     const scannedData = e.detail.value;
  //     setScannedData(scannedData);
  //     // console.log('Scanned id', scannedData);
  //     try {
  //       console.log(token,' token before scanning');
  //       const response = await axios.put(
  //         `${API.BASE_URL}order/delivered`,
  //         {
  //           "scanOrderId": e.detail.value.replace(/"/g, ''),
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       if (response.status === 200) {
  //         toast.success("Order status updated successfully", {
  //           autoClose: 3000,
  //         });
  //       } else {
  //         console.error('Error updating order status:', response.data);
  //       }
  //     } catch (error) {
  //       console.error('Error updating order status:', error);
  //     }
  //   };
  //   document.addEventListener('scanEnd', handleScan);
  //   return () => {
  //     document.removeEventListener('scanEnd', handleScan);
  //   };
  // }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");

    let firstCharTime = 0;
    let lastCharTime = 0;
    let scannedString = "";
    let testTimer = null;

    const options = {
      timeBeforeScanTest: 200,
      startChar: [120], // scanner prefix
      endChar: [13], // Enter key
      avgTimeByChar: 40,
      minLength: 6,
    };

    const resetScanner = () => {
      firstCharTime = 0;
      lastCharTime = 0;
      scannedString = "";
      if (testTimer) clearTimeout(testTimer);
      testTimer = null;
    };

    const processScan = async () => {
      const isValidScan =
        scannedString.length >= options.minLength &&
        lastCharTime - firstCharTime <
        scannedString.length * options.avgTimeByChar;

      if (!isValidScan) {
        resetScanner();
        return;
      }

      const barcode = scannedString.replace(/"/g, "");

      setScannedData(barcode);

      try {
        console.log(token, " token before scanning");

        const response = await axios.put(
          `${API.BASE_URL}order/delivered`,
          {
            scanOrderId: barcode,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          toast.success("Order status updated successfully", {
            autoClose: 3000,
          });
        } else {
          console.error("Error updating order status:", response.data);
        }
      } catch (error) {
        console.error("Error updating order status:", error);
        toast.error("Failed to update order status");
      }

      resetScanner();
    };

    const handleKeyDown = (e) => {
      const keyCode = e.which || e.keyCode;

      // Start character: 120
      if (!firstCharTime && options.startChar.includes(keyCode)) {
        e.preventDefault();
        scannedString = "";
        firstCharTime = Date.now();
        lastCharTime = Date.now();
        return;
      }

      // End character: Enter
      if (firstCharTime && options.endChar.includes(keyCode)) {
        e.preventDefault();
        lastCharTime = Date.now();
        processScan();
        return;
      }
    };

    const handleKeyPress = (e) => {
      const keyCode = e.which || e.keyCode;

      if (!firstCharTime) {
        firstCharTime = Date.now();
      }

      lastCharTime = Date.now();

      // Ignore start/end characters
      if (
        options.startChar.includes(keyCode) ||
        options.endChar.includes(keyCode)
      ) {
        return;
      }

      scannedString += String.fromCharCode(keyCode);

      if (testTimer) clearTimeout(testTimer);

      testTimer = setTimeout(() => {
        processScan();
      }, options.timeBeforeScanTest);
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keypress", handleKeyPress);

    return () => {
      resetScanner();
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  const theme = createTheme({
    typography: {
      fontFamily: 'Red Hat Text, sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <BrowserRouter>
          <ScannerComponent />
          <AppRoutes />
        </BrowserRouter>
        <ToastContainer position="bottom-center" autoClose={3000} theme="colored" hideProgressBar={true} pauseOnHover={false} limit={3} />
      </div>
    </ThemeProvider>
  );
}

export default App;